// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FiTwitter, FiLinkedin, FiMail } from 'react-icons/fi';
import { SUPPORT_EMAIL } from '../shared/constants/contactInfo';

function Footer({ variant = 'full' }) {
  const currentYear = new Date().getFullYear();

  // Minimal footer for authenticated pages
  if (variant === 'minimal') {
    return (
      <footer className="bg-warm-dark border-t border-white/5 py-6 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-cream/30">
              © {currentYear} NextAInsight. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <Link to="/privacy-policy" className="text-xs text-cream/30 hover:text-cream/60 transition-colors">
                Privacy
              </Link>
              <Link to="/terms-of-service" className="text-xs text-cream/30 hover:text-cream/60 transition-colors">
                Terms
              </Link>
              <Link to="/cookie-policy" className="text-xs text-cream/30 hover:text-cream/60 transition-colors">
                Cookies
              </Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  // Full footer for landing page
  return (
    <footer className="bg-warm-black border-t border-warm-border pt-16 pb-8 text-sm">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-16">
          
          {/* Column 1: Product */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold text-cream uppercase tracking-widest mb-6">Product</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-cream/50 hover:text-slate-blue transition-colors font-medium">Features</Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-cream/50 hover:text-slate-blue transition-colors font-medium">How It Works</Link>
              </li>
               <li>
                <Link to="/about" className="text-cream/50 hover:text-slate-blue transition-colors font-medium">About Us</Link>
              </li>
            </ul>
          </div>

          {/* Column 2: Legal */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold text-cream uppercase tracking-widest mb-6">Legal</h4>
             <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" className="text-cream/50 hover:text-slate-blue transition-colors font-medium">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-cream/50 hover:text-slate-blue transition-colors font-medium">Terms of Service</Link>
              </li>
              <li>
                 <Link to="/cookie-policy" className="text-cream/50 hover:text-slate-blue transition-colors font-medium">Cookie Policy</Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Connect */}
          <div className="space-y-4">
            <h4 className="text-xs font-bold text-cream uppercase tracking-widest mb-6">Connect</h4>
            <ul className="space-y-3">
              <li>
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-cream/50 hover:text-slate-blue transition-colors font-medium flex items-center gap-2">
                  <FiMail className="h-4 w-4" />
                  Contact Us
                </a>
              </li>
            </ul>
            <div className="flex items-center gap-4 pt-4">
              <span className="p-2 rounded-lg bg-warm-gray/10 text-cream/20 cursor-default" title="Coming soon" aria-label="Twitter (Coming soon)">
                <FiTwitter className="h-5 w-5" />
              </span>
              <span className="p-2 rounded-lg bg-warm-gray/10 text-cream/20 cursor-default" title="Coming soon" aria-label="LinkedIn (Coming soon)">
                <FiLinkedin className="h-5 w-5" />
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-warm-border pt-8">
          <p className="text-xs text-cream/30 text-center">
            © {currentYear} NextAInsight. Empowering creators with AI-driven content strategy.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;